<script setup lang="ts">
import type { CustomerDetails } from "@/schemas/customer";

const props = defineProps<{ customerDetails: CustomerDetails }>();
const countryLabel = computed(() => countries[props.customerDetails.country].name);
const stateLabel = computed(() => countries[props.customerDetails.country].states[props.customerDetails.state]);
</script>

<template>
  <div class="space-y-2">
    <div class="leading-none">
      <div class="text-lg font-medium">
        {{ customerDetails.first_name }} {{ customerDetails.last_name }}
      </div>
      <div v-if="customerDetails.company" class="text-muted">
        {{ customerDetails.company }}
      </div>
    </div>
    <div v-if="customerDetails.prefix === 'billing'" class="flex items-center gap-1.5 text-sm">
      <span class="i-lucide-mail size-4 text-neutral-400" />
      {{ customerDetails.email }}
    </div>
    <div v-if="customerDetails.phone" class="flex items-center gap-1.5 text-sm">
      <span class="i-lucide-phone size-4 text-neutral-400" />
      {{ customerDetails.phone }}
    </div>
    <div class="flex gap-1.5 text-sm">
      <span class="i-lucide-map-pin size-4 text-neutral-400" />
      <address class="not-italic">
        {{ customerDetails.address_1 }}<br v-if="customerDetails.address_1">
        {{ customerDetails.address_2 }}<br v-if="customerDetails.address_2">
        {{ customerDetails.city }} ({{ stateLabel }})
        {{ customerDetails.postcode }}<br>
        {{ countryLabel }}
      </address>
    </div>
  </div>
</template>
